import styled from '@emotion/styled';
import { useReleaseFlag, useUser } from '@libs/contexts';
import { HeaderControlGroup, HeaderControlGroupDivider } from '../components/HeaderControlGroup';
import { FEATURE_FLAG } from '../constants/FeatureFlag';
import { useOperationControl } from '../context';
import { SpaceSwitcher } from '../features/space-switch';
import { ProcessingMonthLabel } from './ProcessingMonthLabel';
import { ProcessingMonthLink } from './ProcessingMonthLink';
import { SandboxLabel } from './SandboxLabel';

const LabelContainer = styled.div`
  display: flex;
  gap: 5px;
`;

/**
 * ヘッダーの自由枠に並べるラベル。
 *
 * 既存UI（v1）画面（{@link ContainerWithContext}）向け。`/fa/space`（新UI/v2、
 * {@link ContainerV2}）はヘッダーに処理月度ラベルを置かないため、こちらとは別に組む。
 *
 * 運用開始前は従来の処理月度ラベル、運用開始後は台帳切替と処理月度を 1 つの枠に並べて出す。
 * feature flag（申請明細照会）が off なら、運用開始後でも従来の処理月度ラベルを出す。
 */
export function HeaderLabels() {
  const { user } = useUser();
  const { isStarted } = useOperationControl();
  const { isEnabled } = useReleaseFlag(FEATURE_FLAG.FA_REQUEST_DETAIL_REFERENCE_V1);
  const isSpaceSelectable = isStarted && isEnabled;

  return (
    <LabelContainer>
      {isSpaceSelectable && (
        <HeaderControlGroup id="global-space-switch-button">
          <SpaceSwitcher />
          <HeaderControlGroupDivider />
          <ProcessingMonthLink />
        </HeaderControlGroup>
      )}
      {user?.isSandbox && <SandboxLabel />}
      {!isSpaceSelectable && <ProcessingMonthLabel />}
    </LabelContainer>
  );
}
